<template>
  <div>
    <div class="row" v-if="order">
      <div class="col-sm-6">
        <div class="panel">
          <div class="panel-body">
            <!-- <div>
              <span class="text-main text-semibold">新旧钻头：</span>
              {{ order.is_drill_new == 2 ? '旧钻头' : '新钻头' }}
            </div> -->
            <template v-if="order.is_drill_new == 2">
              <!-- <div>
                <span class="text-main text-semibold">序列号：</span>
                {{ order.old_drill_serial_number }}
              </div> -->
              <div>
                <span class="text-main text-semibold">维修基地：</span>
                {{ order.fix_base_name }}
              </div>
            </template>
            <div>
              <span class="text-main text-semibold">钻头类型：</span>
              {{ order.drill_type_name }}
            </div>
            <div>
              <span class="text-main text-semibold">规格：</span>
              {{ order.drill_size }}
            </div>
            <div>
              <span class="text-main text-semibold">型号：</span>
              {{ order.model_number }}
            </div>
            <div>
              <span class="text-main text-semibold">零件号：</span>
              {{ order.component_number }}
            </div>
            <div>
              <span class="text-main text-semibold">数量：</span>
              {{ order.drill_number }}
            </div>
            <div>
              <span class="text-main text-semibold">使用区块：</span>
              {{ order.block_info }}
            </div>
            <div>
              <span class="text-main text-semibold">下料：</span>
              {{ order.cut_info }}
            </div>
            <div class="mar-top">
              <span class="text-main text-semibold">交货紧急程度：</span>
              {{ order.urgent_level_info }}
            </div>
            <div>
              <span class="text-main text-semibold">销售类型：</span>
              {{ order.sale_type_info }}
            </div>
            <div v-if="order.is_drill_new == 2">
              <span class="text-main text-semibold">维修方案：</span>
              {{ order.fix_plan_type }}
            </div>
            <div>
              <span class="text-main text-semibold">喷嘴安装方式：</span>
              {{ order.nozzle_install_info }}
            </div>
            <div>
              <span class="text-main text-semibold">喷嘴：</span>
              {{ order.nozzle }}
            </div>
            <div>
              <span class="text-main text-semibold">包装：</span>
              {{ order.package_type_info }}
            </div>

            <div class="mar-top">
              <span class="text-main text-semibold">备注：</span>
              {{ order.remark }}
            </div>

            <template v-if="order.status > 3">
              <div class="mar-top">
                <span class="text-main text-semibold">外协厂家：</span>
                {{ order.factory.name }}
              </div>
              <div>
                <span class="text-main text-semibold">交货时间：</span>
                {{ order.deliver_time }}
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="panel">
          <div class="panel-heading">
            <h3 class="panel-title">订单操作记录</h3>
          </div>
          <div class="panel-body">
            <div class="timeline">
              <!-- Timeline header -->
              <!-- <div class="timeline-header">
					                <div class="timeline-header-title bg-success">Now</div>
                  </div>-->
              <div class="timeline-entry" v-for="item in logs" :key="item.id">
                <div class="timeline-stat">
                  <div class="timeline-icon">
                    <img src="../../../assets/images/avatar.png" alt="Image" />
                  </div>
                  <div class="timeline-time">
                    {{ $time(item.created_at).format('YYYY-MM-DD HH:mm') }}
                  </div>
                </div>
                <div class="timeline-label">
                  <p class="text-main text-semibold">
                    <span class="text-info">{{ item.user_name }}</span>
                    {{ item.category_name }}
                  </p>
                  <span v-html="item.content" v-if="item.content"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p v-else class="text-center mt-20">无订单信息。</p>
  </div>
</template>

<script>
import { drillOrderInfo } from '@/service/getData'

const driilTypeName = {
  2: 'PDC钻头',
  3: '复合钻头',
  4: '矿用钻头',
}

export default {
  props: {
    serialNumber: String,
  },
  data() {
    return {
      order: null,
      logs: [],
    }
  },
  watch: {
    serialNumber() {
      this.getOrderInfo()
    },
  },
  created() {
    this.getOrderInfo()
  },
  methods: {
    async getOrderInfo() {
      let res = await drillOrderInfo(this.serialNumber)
      if (res.status == 0 && res.data.id) {
        res.data.drill_type_name = driilTypeName[res.data.drill_type]
        this.order = res.data
        this.logs = res.data.order_logs || []
      } else {
        this.order = null
        this.logs = []
      }
    },
  },
}
</script>